import React, { useState, useEffect } from 'react'

import axios from 'axios'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import * as htmlToImage from 'html-to-image'
import { useSelector } from 'react-redux'

import { Rnd } from 'react-rnd'
import { Button, Input, Upload, Drawer, Select } from 'antd'
import { SketchPicker } from 'react-color'
import { uniqueNamesGenerator, adjectives, colors, animals } from 'unique-names-generator'

import RpcApiClient from 'datasources/RpcApiClient'
import tychoLogo from 'assets/tycho-logo.png'
import { getEnv } from 'configurations'

const TYCHO_RPC_API = getEnv('REACT_APP_TYCHO_RPC_API')
const TYCHO_DOCUMENTS = getEnv('REACT_APP_TYCHO_DOCUMENTS')

const { Option } = Select

function UnifilarCards(props) {
  return (
    <>
      <Rnd
        default={{
          x: 150,
          y: 150,
          width: 200,
          height: 130,
        }}
        minWidth={200}
        minHeight={40}
        bounds="parent"
      >
        <div
          className="box"
          style={{
            border: '2px solid black',
            backgroundColor: 'white',
            width: '100%',
            height: '100%',
          }}
        >
          <div
            style={{
              backgroundColor: props.color,
              width: '100%',
              minHeight: '40px',
              textAlign: 'center',
              color: 'white',
            }}
          >
            <div>
              <strong style={{ fontSize: '14px' }}>{props.name}</strong>
            </div>
            <div>
              <strong style={{ fontSize: '12px' }}>Max Injection Capacity</strong>
            </div>
            <div>
              <strong style={{ fontSize: '10px' }}>{props.voltage_sbn_bus}</strong>
            </div>
          </div>
          <table style={{ width: '100%' }}>
            <tr>
              <td style={{ textAlign: 'center' }}>
                <strong>Solar PV</strong>
              </td>
              <td>
                <strong>{props.sbn_bus_maxn1}</strong>
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'center' }}>
                <strong>Wind</strong>
              </td>
              <td>
                <strong>{props.sbn_bus_maxn1}</strong>
              </td>
            </tr>
          </table>
        </div>
      </Rnd>

      <Rnd
        default={{
          x: 90,
          y: 90,
          width: 50,
          height: 50,
        }}
        minWidth={50}
        minHeight={50}
        bounds="parent"
      >
        <div
          style={{
            height: '50px',
            width: '50px',
            backgroundColor: props.color,
            borderRadius: '50%',
            textAlign: 'center',
            lineHeight: '50px',
          }}
        >
          <strong style={{ color: 'white' }}>{props.index + 1}</strong>
        </div>
      </Rnd>

      <Rnd
        default={{
          x: 100,
          y: 100,
          width: 50,
          height: 50,
        }}
        minWidth={50}
        minHeight={50}
        bounds="parent"
      >
        <div
          style={{
            height: '50px',
            width: '50px',
            backgroundColor: props.color,
            borderRadius: '50%',
            textAlign: 'center',
            lineHeight: '50px',
          }}
        >
          <strong style={{ color: 'white' }}>{props.index + 1}</strong>
        </div>
      </Rnd>

      <Rnd
        default={{
          x: 0,
          y: 0,
          width: 300,
          height: 40,
        }}
        minWidth={300}
        minHeight={40}
        bounds="parent"
      >
        <div
          style={{
            backgroundColor: '#313c40',
            width: '300px',
            height: '40px',
            backgroundImage: `url(${tychoLogo})`,
            backgroundSize: 'cover',
          }}
        ></div>
      </Rnd>
    </>
  )
}

function getRandomName() {
  const randomName = uniqueNamesGenerator({ dictionaries: [adjectives, colors, animals] })
  const shortName = uniqueNamesGenerator({
    dictionaries: [adjectives, animals, colors],
    length: 2,
  })
  return shortName
}

function UnifilarEditor(props) {
  const [showCardDrawer, setShowCardDrawer] = useState(false)
  const [cards, setCards] = useState([])
  const [selectedCard, setSelectedCard] = useState({})
  const [unifilar, setUnifilar] = useState()
  const [unifilarTitle, setUnifilarTitle] = useState('Diagrama ' + getRandomName())
  const [unifilarWidth, setUnifilarWidth] = useState(0)
  const [unifilarHeight, setUnifilarHeight] = useState(0)
  const [uploading, setUploading] = useState(false)
  const [uploaded, setUploaded] = useState(false)

  const authData = useSelector((state) => state.auth.authData)
  const [unifilarData, setUnifilarData] = useState([])

  const [loadingTags, setLoadingTags] = useState(false)
  const [tags, setTags] = useState([])

  const getTags = () => {
    setLoadingTags(false)
    RpcApiClient.getTags().then((data) => {
      setTags(data.data.data)
      setLoadingTags(true)
    })
  }

  let unifilarTag = ''
  if (loadingTags) {
    unifilarTag = tags.find((element) => element.name === 'unifilar').tag_id
  }

  useEffect(() => {
    getTags()
  }, [authData])

  const printDocument = () => {
    const input = document.getElementById('unifilarPrint')
    const diagramElement = document.getElementById('diagrama')
    const height = diagramElement.naturalHeight
    const width = diagramElement.naturalWidth

    htmlToImage
      .toPng(input)
      .then((dataUrl) => {
        setUploading(true)
        const link = document.createElement('a')
        link.href = dataUrl
        link.setAttribute('download', unifilarTitle + '.png')
        document.body.appendChild(link)
        link.click()

        fetch(dataUrl).then(async (response) => {
          const contentType = response.headers.get('content-type')
          const blob = await response.blob()
          const file = new File([blob], unifilarTitle + '.png', { contentType })
          console.log(file)
          let config = {
            headers: {
              Authorization: authData.jwtToken,
              'Content-Type': 'application/json',
            },
          }
          axios
            .post(`${TYCHO_RPC_API}/rpc/request_signed_url`, { upload_to: file.name, content_type: file.type }, config)
            .then((presignetUrlResponse) => {
              console.log(presignetUrlResponse)
              const formData = new FormData()
              const fields = presignetUrlResponse.data.upload_url.fields

              Object.keys(fields).forEach((key) => {
                formData.append(key, fields[key])
              })
              formData.append('file', file)

              fetch(presignetUrlResponse.data.upload_url.url, {
                method: 'POST',
                body: formData,
                mode: 'no-cors',
              }).then((response) => {
                RpcApiClient.createDocument({
                  document_id: file.name,
                  name: file.name,
                  type: 'image/png',
                  tags: [unifilarTag],
                }).then(() => {
                  setUploading(false)
                  setUploaded(true)
                })
              })
            })
        })
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error('oops, something went wrong!', error)
      })
  }

  const uploadUnifilar = (file) => {
    let img = document.getElementById('diagramaHide')
    img.setAttribute('src', URL.createObjectURL(file))
    setUnifilar(URL.createObjectURL(file))
    setUploaded(false)
    setUnifilarTitle('Diagrama ' + getRandomName())
  }

  let content = <div></div>

  if (!unifilar) {
    content = (
      <div style={{ height: '100%', width: '100%', textAlign: 'center' }}>
        <div style={{ marginTop: '20px' }}>
          <Upload showUploadList={false} beforeUpload={uploadUnifilar}>
            <Button type="primary">Upload Unifilar</Button>
          </Upload>
        </div>
      </div>
    )
  } else {
    content = (
      <div style={{ height: '100%' }}>
        <Drawer
          title="Card Editor"
          placement="right"
          closable={false}
          onClose={() => setShowCardDrawer(false)}
          visible={showCardDrawer}
          width={650}
        >
          <div>
            <strong>Search</strong>
            <div>
              <Select
                showSearch
                onChange={(value) => {
                  setSelectedCard({ ...selectedCard, ...unifilarData[value] })
                }}
                onSearch={(value) => {
                  RpcApiClient.searchUnifilarData(authData.token, { text: value }).then((response) => {
                    setUnifilarData(response.data.data)
                  })
                }}
                style={{ marginTop: '5px', width: '100%' }}
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                {unifilarData.map((data, index) => {
                  return (
                    <Option key={index} value={index}>
                      {data.name + ' - ' + data.zone_name + ' - ' + data.sbn_bus_acronym}
                    </Option>
                  )
                })}
              </Select>
            </div>

            <strong>Card Name</strong>
            <Input
              style={{ marginTop: '5px' }}
              value={selectedCard.name}
              onChange={(e) => setSelectedCard({ ...selectedCard, name: e.target.value })}
            />

            <div style={{ marginTop: '10px' }}>
              <strong>Max Injection Capacity</strong>
            </div>
            <Input
              style={{ marginTop: '5px' }}
              value={selectedCard.voltage_sbn_bus + ' kV Bus'}
              onChange={(e) =>
                setSelectedCard({
                  ...selectedCard,
                  voltage_sbn_bus: e.target.value,
                })
              }
            />

            <div style={{ marginTop: '10px' }}>
              <strong>Solar PV</strong>
            </div>
            <Input
              style={{ marginTop: '5px' }}
              value={selectedCard.sbn_bus_maxn1}
              onChange={(e) => setSelectedCard({ ...selectedCard, sbn_bus_maxn1: e.target.value })}
            />

            <div style={{ marginTop: '10px' }}>
              <strong>Wind</strong>
            </div>
            <Input
              style={{ marginTop: '5px' }}
              value={selectedCard.sbn_bus_maxn1}
              onChange={(e) => setSelectedCard({ ...selectedCard, sbn_bus_maxn1: e.target.value })}
            />

            <div style={{ marginTop: '10px' }}>
              <strong>Color</strong>
            </div>
            <div style={{ marginTop: '5px' }}>
              <SketchPicker
                color={selectedCard.color}
                onChange={(color) => setSelectedCard({ ...selectedCard, color: color.hex })}
                presetColors={['#fff', '#ff0']}
              />
            </div>

            <Button
              style={{ width: '100%', marginTop: '10px' }}
              type="primary"
              onClick={() => {
                let updatedCards = [...cards]
                updatedCards[selectedCard.index] = selectedCard
                setCards(updatedCards)
              }}
            >
              Save
            </Button>

            <Button
              style={{ width: '100%', marginTop: '10px' }}
              type="danger"
              onClick={() => {
                let updatedCards = [...cards]

                updatedCards = updatedCards.filter((card, index) => index !== selectedCard.index)

                setCards(updatedCards)
              }}
            >
              Delete
            </Button>
          </div>
        </Drawer>

        <div>
          <div
            style={{
              width: '100%',
              textAlign: 'center',
              marginTop: '10px',
            }}
          >
            <Upload showUploadList={false} beforeUpload={uploadUnifilar}>
              <Button style={{ marginRight: '20px' }} type="primary">
                Upload Unifilar
              </Button>
            </Upload>

            <Button
              style={{ marginRight: '20px' }}
              type="primary"
              onClick={() =>
                setCards([
                  ...cards,
                  {
                    name: 'San Luis de la Paz II',
                    maxInjectionCapacity: 'xxx kV Bus',
                    solarPv: '[xxx]',
                    wind: '[xxx]',
                    color: '#4e4e4e',
                  },
                ])
              }
            >
              Add card
            </Button>

            <Button type="primary" onClick={printDocument} loading={uploading}>
              Save as PNG
            </Button>

            <div style={{ marginTop: '10px' }}>
              {cards.map((card, index) => (
                <Button
                  style={{ marginRight: '10px' }}
                  type="primary"
                  onClick={() => {
                    setShowCardDrawer(true)
                    setSelectedCard({ ...card, index: index })
                  }}
                >
                  {index + 1}
                </Button>
              ))}
            </div>
          </div>

          <div
            style={{
              margin: 'auto',
              marginTop: '20px',
              height: unifilarHeight,
              width: unifilarWidth,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Input
                style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#1a2022',
                }}
                placeholder="Borderless"
                bordered={false}
                value={unifilarTitle}
                onChange={(evt) => setUnifilarTitle(evt.target.value)}
              />

              {uploaded && (
                <a
                  href={TYCHO_DOCUMENTS + unifilarTitle + '.png'}
                  without
                  rel="noreferrer"
                  target="_blank"
                  style={{
                    fontSize: '20px',
                    width: '70px',
                  }}
                >
                  See file
                </a>
              )}
            </div>
            <div
              id="unifilarPrint"
              style={{
                position: 'relative',
                overflow: 'hidden',
                height: unifilarHeight,
                width: unifilarWidth,
              }}
            >
              <img
                id="diagrama"
                src={unifilar}
                style={{
                  height: unifilarHeight,
                  width: unifilarWidth,
                  objectFit: 'cover',
                }}
              />

              <Rnd
                default={{
                  x: 10,
                  y: 10,
                  width: 150,
                  height: 150,
                }}
                minWidth={150}
                minHeight={20}
                bounds="parent"
              >
                <div
                  className="box"
                  style={{
                    border: '5px solid #d01212',
                    boxShadow: 'rgba(0, 0, 0, 0.5) 0px 0px 0px 99999px',
                    width: '100%',
                    height: '100%',
                  }}
                ></div>
              </Rnd>

              {cards.map((card, index) => (
                <UnifilarCards {...{ ...card, index: index }} />
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <img
        id="diagramaHide"
        style={{ position: 'absolute', zIndex: '-1000', top: '-10000px' }}
        onLoad={() => {
          let img = document.getElementById('diagramaHide')
          let unifilarWidth = img.clientWidth
          let unifilarHeight = img.clientHeight
          setUnifilarWidth(unifilarWidth)
          setUnifilarHeight(unifilarHeight)
        }}
      />

      {content}
    </div>
  )
}

export default UnifilarEditor
